import styled from 'styled-components';

export const EventTime = styled.p`
  width: 100%;
  display: block;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.4px;
  color: #dddbdb;
  margin-bottom: 0;
`;
